export default __webpack_public_path__ + "static/media/studio.3fa0763c.jpg";